import dataSources from "dataSources";

export const getIdentity = async () => {
  try {
    const { data: { identity } } = await dataSources.auth.getIdentity();
    return identity;
  } catch (e) {
    return null
  }
}